import { useRoutes } from 'react-router-dom';
import Layout from './layouts'
import Staking from "./pages/Staking"

const Router = () => {
    return useRoutes([
        {
            path: "/",
            // element: <Staking />
            element: <Layout />,
            children: [
                // { path: "/", element: <Staking /> },
                { path: '/staking', element: <Staking /> }
                // { path: "/project", element: <Project /> },
                // { path: "/project/create", element: <ProjectCreate /> },
                // { path: "/entry", element: <Entry /> },
                // { path: "/raffle", element: <Raffle /> },
                // { path: "/setting", element: <Setting />},
                // { path: "/collab", element: <Collab />},
                // { path: "/collab/detail", element: <Detail />},
                // { path: "/collab/create", element: <Create />},
            ]
        }
    ])
}

export default Router;